import React from 'react';
import { Platform, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { COLORS } from '../constants/theme';

interface DashboardWidgetReorderButtonsProps {
  readonly widgetTitle: string;
  readonly canMoveUp: boolean;
  readonly canMoveDown: boolean;
  readonly canMoveLeft?: boolean;
  readonly canMoveRight?: boolean;
  readonly onMoveUp: () => void;
  readonly onMoveDown: () => void;
  readonly onMoveLeft?: () => void;
  readonly onMoveRight?: () => void;
}

const HIT_SLOP = { top: 6, bottom: 6, left: 6, right: 6 };

export const DashboardWidgetReorderButtons: React.FC<DashboardWidgetReorderButtonsProps> = ({
  widgetTitle,
  canMoveUp,
  canMoveDown,
  canMoveLeft = false,
  canMoveRight = false,
  onMoveUp,
  onMoveDown,
  onMoveLeft,
  onMoveRight,
}) => (
  <View style={styles.group}>
    {onMoveLeft ? (
      <TouchableOpacity
        style={[styles.button, !canMoveLeft && styles.buttonDisabled]}
        onPress={onMoveLeft}
        disabled={!canMoveLeft}
        activeOpacity={0.7}
        hitSlop={HIT_SLOP}
        accessibilityRole="button"
        accessibilityLabel={`Move ${widgetTitle} left`}
        accessibilityState={{ disabled: !canMoveLeft }}
      >
        <Text style={styles.buttonText}>←</Text>
      </TouchableOpacity>
    ) : null}
    <TouchableOpacity
      style={[styles.button, !canMoveUp && styles.buttonDisabled]}
      onPress={onMoveUp}
      disabled={!canMoveUp}
      activeOpacity={0.7}
      hitSlop={HIT_SLOP}
      accessibilityRole="button"
      accessibilityLabel={`Move ${widgetTitle} up`}
      accessibilityState={{ disabled: !canMoveUp }}
    >
      <Text style={styles.buttonText}>↑</Text>
    </TouchableOpacity>
    <TouchableOpacity
      style={[styles.button, !canMoveDown && styles.buttonDisabled]}
      onPress={onMoveDown}
      disabled={!canMoveDown}
      activeOpacity={0.7}
      hitSlop={HIT_SLOP}
      accessibilityRole="button"
      accessibilityLabel={`Move ${widgetTitle} down`}
      accessibilityState={{ disabled: !canMoveDown }}
    >
      <Text style={styles.buttonText}>↓</Text>
    </TouchableOpacity>
    {onMoveRight ? (
      <TouchableOpacity
        style={[styles.button, !canMoveRight && styles.buttonDisabled]}
        onPress={onMoveRight}
        disabled={!canMoveRight}
        activeOpacity={0.7}
        hitSlop={HIT_SLOP}
        accessibilityRole="button"
        accessibilityLabel={`Move ${widgetTitle} right`}
        accessibilityState={{ disabled: !canMoveRight }}
      >
        <Text style={styles.buttonText}>→</Text>
      </TouchableOpacity>
    ) : null}
  </View>
);

const styles = StyleSheet.create({
  group: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  button: {
    minWidth: 44,
    minHeight: 44,
    paddingHorizontal: 8,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#E5E7EB',
    backgroundColor: COLORS.white,
    alignItems: 'center',
    justifyContent: 'center',
    ...Platform.select({
      web: {
        cursor: 'pointer',
      },
    }),
  },
  buttonDisabled: {
    opacity: 0.4,
    ...Platform.select({
      web: {
        cursor: 'not-allowed',
      },
    }),
  },
  buttonText: {
    fontSize: 18,
    lineHeight: 22,
    color: '#374151',
    fontFamily: 'Montserrat_600SemiBold',
  },
});
